export const profile = {
  name: 'Thomas R. Conroy',
  headline: 'Board Director & Construction Executive',
  subHeadline:
    'Regional P&L Leadership & Business Unit Turnaround | $850M+ Capital Secured',
  location: 'Los Angeles Metropolitan Area',
  entity: 'Founder & Principal, Conroy Advisory Group, LLC',
  education: 'Purdue University, BS',
  portraitUrl:
    'https://cdn.magicpatterns.com/uploads/6nWz3PETMDotA9NDUDsQSN/Thomas_ConroyPics.png',
  narrative: [
    'Thomas Conroy is a construction executive and board director with 35+ years delivering institutional capital programs, including 15+ years of multi-state regional leadership across California, Nevada, and the Western United States. He has carried full regional P&L responsibility, stood up new offices, and led business units through turnaround to sustained profitability.',
    'His portfolio spans more than $850M in cumulative capital and contract awards — acute-care hospitals under HCAI/OSHPD oversight, live airport terminals delivered without interrupting operations, courthouses, and corporate headquarters. He is equally comfortable in a GMP negotiation, a joint-venture steering committee, and a board briefing.',
    'Through Conroy Advisory Group, LLC, he now advises owners, boards, and contractors on capital strategy, governance, alternative delivery, and enterprise risk on complex programs.',
  ],
  awards: [
    {
      title: 'GLAACC 2025 Contractor of the Year',
      issuer: 'Greater Los Angeles African American Chamber of Commerce',
    },
    {
      title: 'ASCE California Outstanding Airport Project',
      issuer: 'American Society of Civil Engineers',
    },
    {
      title: 'ENR Best Project — Award of Merit',
      issuer: 'Engineering News-Record',
    },
  ],
  contact: {
    address: 'Los Angeles, California',
    phoneDisplay: '+1 (323) 303-6602',
    phoneHref: 'tel:+13233036602',
    email: 'Thomas.R.Conroy@gmail.com',
    linkedIn: 'https://www.linkedin.com/in/thomasrconroy',
  },
}

export const inquiryTypes = [
  'Board Nomination / Directorship',
  'Strategic Capital Project Advisory',
  'Joint-Venture Steering & Governance',
  'Enterprise Risk & Alternative Delivery',
  'Speaking or Executive Briefing',
]
